import { HTTP_METHODS } from '@studio/constants/axios';
import { LOGS_GATEWAY_API_V1 } from '@studio/constants/env-variables';
import type { EncoderLogs } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    params: {} as { encoderId: string },
    query: {} as { end?: string; minlevel?: EncoderLogs.Get.LogLevel; start?: string },
    response: [] as EncoderLogs.Get.LogEntry[],
    url: `${LOGS_GATEWAY_API_V1}/logs/@customerId/encoders/@encoderId`,
  },
};
